import { useModel } from "@stem-sims/nexus"
import { Button, Table } from "react-bootstrap"
import { BeatLoader } from "react-spinners"
import { getSubscriptionInfo } from "shared/routes/account/account-management"

const SubscriptionInfoPage = () => {

    const { response: subscriptionInfo, loading } = useModel({
        model: getSubscriptionInfo
    })

    if (loading || !subscriptionInfo) return <BeatLoader />

  return (
    <div className="mt-4">
        <h4>Subscription Information</h4>
        <div className="d-flex justify-content-center mt-3">
            <Table bordered responsive>
                <tbody className="text-start">
                    <tr>
                        <td className="p-3"><b>Current Subscription Type</b></td>
                        <td className="p-3">
                            <span className="text-primary">{subscriptionInfo.plan}</span>
                        </td>
                    </tr>
                    {!subscriptionInfo.isExpired && <tr>
                        <td className="p-3"><b>Student Seats</b></td>
                        <td className="p-3">
                            <span className={subscriptionInfo.count ? "text-primary" : "text-danger"}>{subscriptionInfo.count}</span>
                        </td>
                    </tr>}
                    <tr>
                        <td className="p-3"><b>Subscription Status</b></td>
                        <td className="p-3">
                            {subscriptionInfo.isExpired ? <span className="text-danger">Expired</span> : <span className="text-success">Valid until {subscriptionInfo.expiration}</span>}
                        </td>
                    </tr>
                    <tr>
                        <td className="p-3"><b>Teacher Resources</b></td>
                        <td className="p-3">
                            <i className={`fas ${(subscriptionInfo.featureTeacher && !subscriptionInfo.isExpired) ? `fa-square-check text-success` : `fa-circle-xmark text-danger`} fs-4`} />
                        </td>
                    </tr>
                    <tr>
                        <td className="p-3"><b>Student Tracking</b></td>
                        <td className="p-3">
                            <i className={`fas ${(subscriptionInfo.featureTracking && !subscriptionInfo.isExpired) ? `fa-square-check text-success` : `fa-circle-xmark text-danger`} fs-4`} />
                        </td>
                    </tr>
                </tbody>
            </Table>
        </div>
        <hr />
        <div>
            {subscriptionInfo.billingPortalSession ? <Button href={subscriptionInfo.billingPortalSession} role="button">Manage Your Subscription</Button> :
                subscriptionInfo.isTrial ? <Button href="/subscribe">Subscribe Now</Button> :
                <Button href="mailto:sales@stemsims.com">Contact Us About Your Subscription</Button>}
        </div>
    </div>
  )
}

export default SubscriptionInfoPage
